import script from "./BajaReport.vue?vue&type=script&setup=true&lang=js"
export * from "./BajaReport.vue?vue&type=script&setup=true&lang=js"

import "./BajaReport.vue?vue&type=style&index=0&id=b8946d00&lang=css"

const __exports__ = script;

export default __exports__